import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'

import { createGlobalStyle } from 'styled-components'

import 'antd/dist/antd.less'

import { createClient } from './utils/apollo/client'
import { Root } from './pages/Root'
import { DDLogProvider, initDDLog } from './components/DDLogProvider'
import { DDLogger } from './components/DDLogger'
import { logVersion } from './utils/version'

import { GlobalFontStyles } from './fonts'

const Styles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    background-color: #f9f9fc;
    font-family: 'Avenir Next Web', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
    margin: 0;
  }

  iframe {
    border-width: 0;
    height: 100vh;
    width: 100%;
  }
`

export const App = () => (
  <DDLogger>
    <GlobalFontStyles />
    <Styles />
    <Root />
  </DDLogger>
)

export const init = async (cb?) => {
  logVersion()

  const client = await createClient()
  const ddLog = initDDLog()

  // Note: only providers should be included here. All other parent components should be placed in the App component above.
  ReactDOM.render(
    <ApolloProvider client={client}>
      <DDLogProvider value={ddLog}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </DDLogProvider>
    </ApolloProvider>,
    document.getElementById('app'),
    cb,
  )
}
